import { PayoutOrderStatus, type PayoutOrder } from '~/entities/payout';

type CanShowSplitOrderActionProps = {
    order: PayoutOrder;
    canSplitOrder: boolean;
};

type ValidateSplitBodyAmountProps = {
    bodyAmount: string | number;
    orderAmount?: string;
    minChildAmount?: string;
};

const normalizeAmount = (value?: string | number) => {
    if (value === undefined || value === '') {
        return NaN;
    }

    return Number(value.toString().replace(',', '.'));
};

export const canShowSplitOrderAction = ({ order, canSplitOrder }: CanShowSplitOrderActionProps) => {
    return canSplitOrder && order.status === PayoutOrderStatus.STATUS_IN_WORK && !order.parentOrderId;
};

export const validateSplitBodyAmount = ({ bodyAmount, orderAmount, minChildAmount }: ValidateSplitBodyAmountProps) => {
    const normalizedBodyAmount = normalizeAmount(bodyAmount);
    const normalizedOrderAmount = normalizeAmount(orderAmount);
    const normalizedMinChildAmount = normalizeAmount(minChildAmount) || 0;

    if (!Number.isFinite(normalizedBodyAmount) || normalizedBodyAmount <= 0) {
        return 'Сумма первой части должна быть больше 0';
    }

    if (!Number.isFinite(normalizedOrderAmount) || normalizedOrderAmount <= 0) {
        return 'Сумма ордера недоступна';
    }

    const tailAmount = normalizedOrderAmount - normalizedBodyAmount;

    if (tailAmount <= 0) {
        return 'Остаток должен быть больше 0';
    }

    if (normalizedBodyAmount === tailAmount) {
        return 'Нельзя делить ордер 50/50';
    }

    if (
        normalizedMinChildAmount > 0 &&
        (normalizedBodyAmount < normalizedMinChildAmount || tailAmount < normalizedMinChildAmount)
    ) {
        return `Обе части должны быть не меньше ${minChildAmount}`;
    }

    return null;
};
